import React from 'react';


export default {
    green: msg => <strong key={msg} className="rh-fg-lime">{msg}</strong>,      // eslint-disable-line
};
